module.exports = __webpack_public_path__ + "static/img/sanye.01fa9ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sanye.png
// module id = 169
// module chunks = 1